<template>
  <div class="metric-form">
    <MetricSelect
      :value="selectedMetric"
      label="Progress Metric*"
      required
      hint="This is the main metric being counted in the progress bar"
      :items="metricOptions"
      data-testid="metric-field-informMetricId"
      @input="setMetric"
    />
    <MetricSelect
      :value="value.rangeStartLabelAttribute"
      label="Left Label"
      hint="This label appears under the progress bar on the left side"
      :items="metricOptions"
      data-testid="metric-field-rangeStartLabelAttribute"
      @input="setField('rangeStartLabelAttribute', $event)"
    />
    <MetricSelect
      :value="value.rangeEndLabelAttribute"
      label="Right Label"
      hint="This label appears under the progress bar on the right side"
      :items="metricOptions"
      data-testid="metric-field-rangeEndLabelAttribute"
      @input="setField('rangeEndLabelAttribute', $event)"
    />
  </div>
</template>

<script>
import MetricSelect from "./MetricSelect.vue";
import { hasMetricBinding, toMetricBinding, toMetricSelectValue } from "./metricOptions";

export default {
  name: "ProgressBarForm",
  components: { MetricSelect },
  props: {
    value: { type: Object, required: true },
    metricOptions: { type: Array, default: () => [] },
    informProgramId: { type: String, default: null },
  },
  emits: ["input", "update:valid"],
  computed: {
    selectedMetric() {
      return toMetricSelectValue(this.value, this.metricOptions);
    },
    isValid() {
      return hasMetricBinding(this.value);
    },
  },
  watch: {
    isValid: {
      immediate: true,
      handler(valid) {
        this.$emit("update:valid", valid);
      },
    },
  },
  methods: {
    setMetric(selectValue) {
      this.$emit("input", {
        ...this.value,
        ...toMetricBinding(selectValue, this.metricOptions, this.informProgramId),
      });
    },
    setField(key, fieldValue) {
      this.$emit("input", { ...this.value, [key]: fieldValue });
    },
  },
};
</script>

<style scoped>
.metric-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
